"use client";

import { motion } from "framer-motion";
import { PropsWithChildren } from "react";

type SeoRevealProps = PropsWithChildren<{
  delay?: number;
  y?: number;
  className?: string;
}>;

export const SeoReveal = ({
  children,
  delay = 0,
  y = 24,
  className,
}: SeoRevealProps) => {
  return (
    <motion.div
      className={className}
      initial={{ opacity: 0, y }}
      whileInView={{ opacity: 1, y: 0 }}
      viewport={{ once: true, amount: 0.2 }}
      transition={{ duration: 0.5, ease: "easeOut", delay }}
    >
      {children}
    </motion.div>
  );
};
